<template>
  <button
    class="decade-btn"
    :class="{ 'decade-btn-active': isActive }"
    @click="onClick"
  >
    <span>{{ decade * 10 + minDecadeAge }}</span>
    <span>-</span>
    <span>{{ decade * 10 + minDecadeAge + 10 - 1 }}</span>
  </button>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    decade: { type: Number },
  },
  data: function () {
    return {}
  },
  computed: {
    isActive: function () {
      if (
        this.$parent.thisDecade === this.decade &&
        this.$parent.showState !== 'LIFE'
      ) {
        return true
      } else {
        return false
      }
    },
    minDecadeAge: function () {
      return this.$parent.pan.minDecadeAge
    },
  },
  methods: {
    onClick: async function () {
      if (this.isActive) {
        this.$parent.showState = 'LIFE'
      } else {
        // this.$parent.showState = 'DECADE'
        const date = moment.tz(
          this.$parent.user.birthday,
          'YYYY-MM-DD HH:mm',
          'Etc/GMT-8'
        )

        this.$parent.thisDecade = this.decade
        this.$parent.thisYear =
          date.year() + this.decade * 10 + this.minDecadeAge - 1

        this.$emit('setDecade')
      }
    },
  },
}
</script>

<style>
.decade-btn {
  width: 100%;
  border: 1px solid black;
  border-radius: 3px;
  background-color: #eee;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  color: black;
}

.decade-btn:active {
  background-color: green;
}

.decade-btn-active {
  background-color: green;
}
</style>
